import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import { ModelModel } from "./dto/model.dto";

import { ModelRepository } from "./model.repository";

export class ModelService extends BaseService {
  private modelRepository = new ModelRepository(this.api, this.configService);

  async getModel(): Promise<ModelModel[]> {
    let dataResult: ModelModel[] = [];
    try {
      const { $functions } = useNuxtApp()
      const res = await this.modelRepository.getModel();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map(e => new ModelModel(e))
        console.log('getModel', resData.data, dataResult)
      }
    } catch (err) {
      console.log(err, ModelService.name);
    }
    return dataResult;
  }
}